import type { RootState } from '@/store/store'
import type { MatterMemberRead } from '@/matter/components/manage-members/schemas'

/* Stable reference for the empty case so useAppSelector doesn't re-render on every dispatch. */
const EMPTY_MEMBERS: MatterMemberRead[] = []

export function selectMatterMembers(state: RootState, matterId: string | undefined): MatterMemberRead[] {
  if (!matterId) return EMPTY_MEMBERS
  return state.collaborationState.membersByMatterId[matterId]?.members ?? EMPTY_MEMBERS
}

export function selectMatterMembersError(state: RootState, matterId: string | undefined): boolean {
  if (!matterId) return false
  return state.collaborationState.membersByMatterId[matterId]?.error ?? false
}

export function selectMatterMembersInitialLoadComplete(state: RootState, matterId: string | undefined): boolean {
  if (!matterId) return false
  return state.collaborationState.membersByMatterId[matterId]?.initialLoadComplete ?? false
}
